import {
  Box,
  Columns,
  ColumnsItem,
  RowItem,
  Rows,
  Text,
  TextLevels,
  Title,
  TitleLevels,
} from '@bytel/trilogy-react-ts';
import theme from '@shared/misc/helpers/theme';

import {
  VictoryAxis,
  VictoryChart,
  VictoryClipContainer,
  VictoryLine,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from 'victory';
import { BoxConsommationGraphProps } from './type';

const axisYStyle = {
  axis: { stroke: 'transparent' },
  ticks: { stroke: 'transparent' },
  tickLabels: {
    fill: 'white',
    fontSize: 8,
    fontFamily: 'Bouygues Read',
  },
};

const axisXStyle = {
  axis: { stroke: 'transparent' },
  ticks: { stroke: 'transparent' },
  tickLabels: {
    fill: 'white',
    fontSize: 8,
    fontFamily: 'Bouygues Read',
    angle: -45,
  },
};

const gridStyle = {
  stroke: 'rgba(255, 255, 255, 0.1)',
  strokeWidth: 1,
};

const toolTipStyle = {
  fill: theme.colors.blue,
  fontSize: 8,
};

const flyoutStyle = {
  stroke: theme.colors.blue,
  strokeWidth: 1,
};

const victoryLineStyle = {
  data: {
    stroke: theme.colors.lightBlue,
    strokeWidth: 2,
    strokeLinecap: 'round',
  },
};

const BoxConsommationGraph = ({
  title,
  graphTitle,
  info,
  consommationData,
  unitToShow,
  exportButton,
}: BoxConsommationGraphProps) => {
  return (
    <Box className="is-fullheight is-fullwidth has-border-radius-large is-primary" data-cy="boxConsommationFlotte-box">
      <Rows>
        <RowItem>
          <Columns>
            <ColumnsItem size={8}>
              <Title level={TitleLevels.TWO} inverted data-cy="boxConsommationFlotte-titre">
                {title}
              </Title>
            </ColumnsItem>
            <ColumnsItem className="has-text-right" data-cy="boxConsommationFlotte-graphExporter">
              {exportButton}
            </ColumnsItem>
          </Columns>
          <Title level={TitleLevels.THREE} inverted data-cy="boxConsommationFlotte-graphtitre">
            {graphTitle}
          </Title>
        </RowItem>
        <RowItem>
          <Columns>
            <ColumnsItem className="is-paddingless">
              <VictoryChart
                height={180}
                padding={{ left: 55, right: 30, top: 30, bottom: 30 }}
                domainPadding={{ x: [10, 0] }}
                containerComponent={
                  <VictoryVoronoiContainer
                    voronoiDimension="x"
                    labels={({ datum }) => `${Number.parseFloat(datum.y).toFixed(2)}`}
                    labelComponent={
                      <VictoryTooltip
                        cornerRadius={4}
                        style={toolTipStyle}
                        flyoutPadding={4}
                        flyoutStyle={flyoutStyle}
                        pointerLength={6}
                        pointerWidth={0}
                      />
                    }
                  />
                }
              >
                <VictoryAxis
                  dependentAxis
                  style={axisYStyle}
                  tickFormat={(tick) => `${tick} ${unitToShow}₂`}
                  tickCount={(consommationData?.length ?? 0) > 1 ? 3 : 1}
                  gridComponent={<line style={gridStyle} />}
                />
                <VictoryAxis
                  style={axisXStyle}
                  tickCount={consommationData?.length ?? 1}
                  gridComponent={<line style={gridStyle} />}
                />

                <VictoryLine
                  groupComponent={<VictoryClipContainer clipPadding={{ top: 5, bottom: 5, right: 5 }} />}
                  style={victoryLineStyle}
                  data={consommationData}
                />
              </VictoryChart>
            </ColumnsItem>
          </Columns>
        </RowItem>
        <RowItem>
          <Text level={TextLevels.ONE} className="has-text-centered" data-cy="boxConsommationFlotte-description">
            {info}
          </Text>
        </RowItem>
      </Rows>
    </Box>
  );
};
export default BoxConsommationGraph;
